import React, { useMemo } from 'react';
import { Button } from 'primereact/button';
import { TypedAplication, Aplicacao } from '../../@types';
import Modal from '../../components/Modal/modal';
import extractProdutosFromAplicacao from './utils';

interface PendingAproveItemModalProps {
  visible: boolean;
  item: Extract<TypedAplication, Aplicacao>;
  onHide: () => void;
  onVerifyExistingApplications: () => void;
  onDeletePendingApplication: () => void;
}

const PendingAproveItemModal: React.FC<PendingAproveItemModalProps> = ({
  visible,
  item,
  onHide,
  onVerifyExistingApplications,
  onDeletePendingApplication,
}) => {
  const produtosModal = useMemo(
    () => extractProdutosFromAplicacao(item),
    [item],
  );

  return (
    <Modal
      visible={visible}
      title={item.tipoOperacao || 'Aplicação de Defensivos'}
      className="pending-aprove-item-modal"
      position="top"
      content={
        <div className="pending-aprove-item-modal-content">
          <div className="pending-aprove-item-modal-summary">
            <div>
              <strong>Propriedade:</strong>
              <span>{item.propriedade.descricao}</span>
            </div>
            {item.gleba?.descricao && (
              <div>
                <strong>Talhão:</strong>
                <span>{item.gleba.descricao}</span>
              </div>
            )}
            <div>
              <strong>Produtos:</strong>
              <span>{produtosModal}</span>
            </div>
          </div>

          <div className="pending-aprove-item-modal-main-actions">
            <Button
              label="Verificar aplicações existentes"
              className="pending-aprove-item-modal-action pending-aprove-item-modal-action-verify"
              onClick={onVerifyExistingApplications}
            />
            <Button
              label="Excluir Aplicação pendente"
              className="pending-aprove-item-modal-action pending-aprove-item-modal-action-delete"
              onClick={onDeletePendingApplication}
            />
          </div>
        </div>
      }
      actionsClassName="pending-aprove-item-modal-footer"
      actions={[
        {
          label: 'Cancelar',
          onClick: onHide,
          buttonProps: {
            className:
              'pending-aprove-item-modal-action pending-aprove-item-modal-action-cancel',
          },
        },
      ]}
      onHide={onHide}
    />
  );
};

export default React.memo(PendingAproveItemModal);
